import { Component, Element, h, Host, Listen, Prop, Watch } from '@stencil/core';
import Util from '../../global/util';
import { default as languageStrings } from '../../global/l10n/OssSkuDialog.json';

@Component({
    tag: 'ti-oss-sku-dialog',
    styleUrl: 'oss-sku-dialog.scss',
    shadow: true
})
export class OssSkuDialog {

    private _skuDialog;

    /**
     * The element for this component
     */
    @Element() _hostElement: HTMLTiOpnSnapshotElement;

    /**
     * Value of locale
     *
     * @type {string}
     * @default 'en-US'
     */
    @Prop() locale: string = 'en-US';
    @Watch('locale')
    handleLocaleChange() {
        this.locale = Util.getValidLocale(this.locale);
    }

    /**
    * Listen for a `tiOssSkuClick` event from opn-details
    *
    * @param event - contains related opn
    */
    @Listen('tiOssSkuClick', { target: 'window' })
    //@ts-ignore
    async onTiOssSkuClick(event) {
        event.stopPropagation();
        this._skuDialog.open();
    }

    render() {
        return (
            <Host>
                <ti-dialog modal ref={el => this._skuDialog = el}>
                    <h2 slot="title" class="ti-add-to-cart-dialog-title">{languageStrings[this.locale]["skuDialogTitle"]}</h2>
                    <div>
                        <p innerHTML={languageStrings[this.locale]["skuDialogMessage"]}></p>
                        <ti-button appearance="link">
                            <a href={languageStrings[this.locale]["skuDialogLinkUrl"]} target='_blank'>{languageStrings[this.locale]["skuDialogLink"]}</a>
                        </ti-button>
                    </div>
                </ti-dialog>
            </Host>
        )
    }
}
